import {ILinkData, INodeData} from '../context-detail-contracts';
import {EmployeeDataType} from '../../../../data-management/data-sources/sources/employees-data-source';

export enum EmployeeRelationshipType {
    None = 0,
    EM = 1,
    LTCoach = 2,
    EMCoachee = 4,
    LTCoachee = 8,
    Firestaerter = 16,
    FirestaerterCoachee = 32
}

export class EmployeeRelationshipData {
    constructor(public relationshipType: EmployeeRelationshipType) {

    }

    public isCoach() {
        return (this.relationshipType & EmployeeRelationshipType.EM) === EmployeeRelationshipType.EM ||
            (this.relationshipType & EmployeeRelationshipType.LTCoach) === EmployeeRelationshipType.LTCoach ||
            (this.relationshipType & EmployeeRelationshipType.Firestaerter) === EmployeeRelationshipType.Firestaerter;
    }

    public isCoachee() {
        return (this.relationshipType & EmployeeRelationshipType.EMCoachee) === EmployeeRelationshipType.EMCoachee ||
            (this.relationshipType & EmployeeRelationshipType.LTCoachee) === EmployeeRelationshipType.LTCoachee ||
            (this.relationshipType & EmployeeRelationshipType.FirestaerterCoachee) === EmployeeRelationshipType.FirestaerterCoachee;
    }

    public hasEMRelation() {
        return (this.relationshipType & EmployeeRelationshipType.EM) === EmployeeRelationshipType.EM ||
            (this.relationshipType & EmployeeRelationshipType.EMCoachee) === EmployeeRelationshipType.EMCoachee;
    }

    public hasLTCoachRelation() {
        return (this.relationshipType & EmployeeRelationshipType.LTCoach) === EmployeeRelationshipType.LTCoach ||
            (this.relationshipType & EmployeeRelationshipType.LTCoachee) === EmployeeRelationshipType.LTCoachee;
    }

    public hasFirestaerterCoachRelation() {
        return (this.relationshipType & EmployeeRelationshipType.Firestaerter) === EmployeeRelationshipType.Firestaerter ||
            (this.relationshipType & EmployeeRelationshipType.FirestaerterCoachee) === EmployeeRelationshipType.FirestaerterCoachee;
    }
}

export class EmployeeNodeData extends EmployeeRelationshipData implements INodeData {
    public x?: number;
    public y?: number;

    constructor(public element: EmployeeDataType, relationshipType: EmployeeRelationshipType) {
        super(relationshipType);
    }
}

export class EmployeeLinkData extends EmployeeRelationshipData implements ILinkData<EmployeeNodeData> {
    constructor(public source: string | EmployeeNodeData, public target: string | EmployeeNodeData, relationshipType: EmployeeRelationshipType) {
        super(relationshipType);
    }
}
